import { convex } from "@/lib/convexClient";
import { api } from "../../convex/_generated/api";

type PanoramaLike = {
  id: string;
  name?: string;
  thumbnail_url?: string | null;
};

/**
 * Fix thumbnail URLs that are pointing to full panorama images instead of actual thumbnails
 * This function can be called from the browser console to fix the database
 */
export const fixThumbnailUrls = async () => {
  try {
    // Get all panoramas with thumbnail URLs
    const panoramas =
      (await convex.query(api.panoramas.listMine, {}))?.filter(
        (panorama: PanoramaLike) => !!panorama.thumbnail_url,
      ) || [];

    let fixedCount = 0;
    let skippedCount = 0;

    for (const panorama of panoramas || []) {
      // Check if the thumbnail URL is actually pointing to a full panorama (contains /raw/ or /panoramas/raw/)
      // Also check for the old structure that might still exist
      if (
        panorama.thumbnail_url &&
        (panorama.thumbnail_url.includes("/panoramas/raw/") ||
          panorama.thumbnail_url.includes("/raw/") ||
          panorama.thumbnail_url.includes("/thumbnails/"))
      ) {
        // Clear the thumbnail URL and set processing status to pending
        try {
          await convex.mutation(api.panoramas.update, {
            id: panorama.id,
            thumbnail_url: "",
            processing_status: "pending",
          });
          fixedCount++;
        } catch (updateError) {
          console.error(`Failed to update panorama ${panorama.name}:`, updateError);
        }
      } else {
        skippedCount++;
      }
    }

    // Only log summary if panoramas were actually fixed
    if (fixedCount > 0) {
      console.log(`Fixed ${fixedCount} panorama thumbnail URLs`);
    }

    return {
      success: true,
      fixedCount,
      skippedCount,
      totalCount: panoramas?.length || 0,
    };
  } catch (error) {
    console.error("Error:", error);
    return { success: false, error: error instanceof Error ? error.message : "Unknown error" };
  }
};

// Make it available globally for browser console access
if (typeof window !== "undefined") {
  const globalWindow = window as Window & { fixThumbnailUrls?: typeof fixThumbnailUrls };
  globalWindow.fixThumbnailUrls = fixThumbnailUrls;
}
